import styled from 'styled-components';

export const NavWrapper = styled.div`
  position: fixed;
  bottom: 0;
  z-index: 300;
`;
